import { expValEquals } from '@atlassian/jira-feature-experiments';

export default {
	get(): boolean {
		return expValEquals(
			'atlassian_projects_-_native_integration',
			'cohort',
			'variation',
			'control',
		);
	},
};
